module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/cartao-caixa-c5208ff95fae1c35384e8af10492faf5.svg";